'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _dateTimeHelper = require('../../../../helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Arrival(props) {
  var components = props.components,
      time = props.time,
      t = props.t;
  var airportName = props.airportName,
      airportCode = props.airportCode,
      city = props.city,
      terminal = props.terminal;

  var styleArriveTitleLabel = {};
  var styleArriveValueLabel = {};
  airportName = airportName || 'Airport Name';
  airportCode = airportCode || 'Airport Code';
  city = city || 'City Name';
  terminal = terminal || t('common.na');

  styleArriveTitleLabel.color = components.ArriveTitleLabel.color;
  styleArriveTitleLabel.fontSize = components.ArriveTitleLabel.fontSize;
  styleArriveTitleLabel.fontWeight = components.ArriveTitleLabel.fontWeight;
  styleArriveTitleLabel.fontStyle = components.ArriveTitleLabel.fontStyle;
  styleArriveTitleLabel.textDecoration = components.ArriveTitleLabel.textDecoration;
  styleArriveTitleLabel.fontFamily = components.ArriveTitleLabel.fontFamily;

  styleArriveValueLabel.color = components.ArriveValueLabel.color;
  styleArriveValueLabel.fontSize = components.ArriveValueLabel.fontSize;
  styleArriveValueLabel.fontWeight = components.ArriveValueLabel.fontWeight;
  styleArriveValueLabel.fontStyle = components.ArriveValueLabel.fontStyle;
  styleArriveValueLabel.textDecoration = components.ArriveValueLabel.textDecoration;
  styleArriveValueLabel.fontFamily = components.ArriveValueLabel.fontFamily;

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Arrival' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: styleArriveTitleLabel },
            t('air.arr')
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(
            'span',
            { style: styleArriveValueLabel },
            airportName,
            ', ',
            city,
            ' (',
            airportCode,
            ') ',
            _dateTimeHelper2.default.getDate(time),
            ' ',
            t('car.at'),
            ' ',
            _dateTimeHelper2.default.getTime(time),
            ' ',
            t('air.terArr'),
            '\xA0',
            terminal
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactI18next.translate)()((0, _reactRedux.connect)(mstp)(Arrival));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Arrival.jsx
// module id = 1467
// module chunks = 0